import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, ClockIcon, PhoneIcon } from 'lucide-react';
export function ContactSection() {
  return <section id="contacto" className="py-24 bg-laura-beige text-laura-dark" data-id="element-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-30">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-31">
            <span className="text-laura-olive text-sm font-bold uppercase tracking-[0.2em] mb-4 block" data-id="element-32">
              Información y Reservas
            </span>
            <h2 className="text-4xl md:text-5xl font-playfair text-laura-wood mb-10" data-id="element-33">
              Ven a visitarnos
            </h2>

            <div className="space-y-8 mb-12" data-id="element-34">
              <div className="flex items-start space-x-4" data-id="element-35">
                <MapPinIcon className="w-6 h-6 text-laura-olive flex-shrink-0 mt-1" data-id="element-36" />
                <div data-id="element-37">
                  <h3 className="font-bold uppercase tracking-wider text-sm mb-1 text-laura-dark" data-id="element-38">
                    Dirección
                  </h3>
                  <p className="text-laura-wood/90 text-lg" data-id="element-39">
                    Calle Emilio de la Tía Fidela, 2<br data-id="element-40" />
                    28360 Villaconejos, Madrid
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4" data-id="element-41">
                <ClockIcon className="w-6 h-6 text-laura-olive flex-shrink-0 mt-1" data-id="element-42" />
                <div data-id="element-43">
                  <h3 className="font-bold uppercase tracking-wider text-sm mb-1 text-laura-dark" data-id="element-44">
                    Horario
                  </h3>
                  <div className="text-laura-wood/90 text-lg space-y-2" data-id="element-45">
                    <p data-id="element-46">
                      <span className="font-medium text-laura-dark" data-id="element-47">
                        Entre semana:
                      </span>
                      <br data-id="element-48" />
                      Menú del día de lunes a viernes.
                      <br data-id="element-49" />
                      <span className="text-laura-oliveDark font-bold" data-id="element-50">
                        Miércoles: Cerrado
                      </span>
                    </p>
                    <p data-id="element-51">
                      <span className="font-medium text-laura-dark" data-id="element-52">
                        Fin de semana:
                      </span>
                      <br data-id="element-53" />
                      Comidas sábado y domingo.
                      <br data-id="element-54" />
                      Cenas viernes y sábado.
                      <br data-id="element-55" />
                      <span className="text-sm italic" data-id="element-56">
                        Menú de fin de semana y raciones.
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-start space-x-4" data-id="element-57">
                <PhoneIcon className="w-6 h-6 text-laura-olive flex-shrink-0 mt-1" data-id="element-58" />
                <div data-id="element-59">
                  <h3 className="font-bold uppercase tracking-wider text-sm mb-1 text-laura-dark" data-id="element-60">
                    Reservas
                  </h3>
                  <p className="text-laura-wood/90 text-lg" data-id="element-61">+34 660 34 37 11</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-62">
              <a href="https://wa.me/34660343711" target="_blank" rel="noopener noreferrer" className="inline-block text-center bg-laura-amber text-laura-dark px-8 py-4 rounded font-bold uppercase tracking-wider hover:bg-laura-gold transition-colors shadow-md" data-id="element-63">
                Reservar por WhatsApp
              </a>
              <a href="tel:+34660343711" className="inline-block text-center bg-laura-wood text-laura-cream px-8 py-4 rounded font-bold uppercase tracking-wider hover:bg-laura-dark transition-colors shadow-md" data-id="element-64">
                Llamar
              </a>
              <a href="https://maps.google.com/?q=Calle+Emilio+de+la+Tía+Fidela+2+28360+Villaconejos+Madrid" target="_blank" rel="noopener noreferrer" className="inline-block text-center border-2 border-laura-wood text-laura-wood px-8 py-4 rounded font-bold uppercase tracking-wider hover:bg-laura-wood hover:text-laura-cream transition-colors shadow-md" data-id="element-65">
                Cómo llegar
              </a>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative h-[500px] rounded-lg overflow-hidden shadow-xl border-4 border-white" data-id="element-66">
            <div className="absolute inset-0 bg-laura-dark/10 z-10 pointer-events-none" data-id="element-67" />
            <img src="https://cdn.magicpatterns.com/uploads/cLFMUeBUcL2pFPsez4kxct/unnamed_(2).webp" alt="Exterior del Restaurante El Rincón de Laura" className="w-full h-full object-cover" data-id="element-68" />

            <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm p-5 rounded-lg z-20 shadow-lg text-center border border-laura-beige" data-id="element-69">
              <p className="font-playfair text-2xl text-laura-wood font-bold" data-id="element-70">
                El Rincón de Laura
              </p>
              <p className="text-sm text-laura-wood/70 mt-1" data-id="element-71">
                Asador tradicional en Villaconejos
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}